import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HomeComponent } from './home/home.component';
import { WelcomeHeaderComponent } from './welcome-header/welcome-header.component';
import { RegistrationComponent } from './registration/registration.component';
import { FormsModule } from '@angular/forms';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { LandingPageComponent } from './landing-page/landing-page.component';
import { GettingStartedComponent } from './getting-started/getting-started.component';
import { ResourcesComponent } from './resources/resources.component';
import { SignupComponent } from './signup/signup.component';
import { AppManagementComponent } from './app-management/app-management.component';
import { EditAppComponent } from './edit-app/edit-app.component';
import { ConfirmationPopoverModule } from 'angular-confirmation-popover';
import { LogoutComponent } from './logout/logout.component';
import { PoliciesCheckComponent } from './policies-check/policies-check.component';
import { ProfileMgmtComponent } from './profile-mgmt/profile-mgmt.component';
import { HeaderComponent } from './header/header.component';
import { TermsConditionsComponent } from './terms-conditions/terms-conditions.component';
import { FooterComponent } from './footer/footer.component';

//import { DialogComponent } from './dialog/dialog.component'

@NgModule({ declarations: [
        AppComponent,
        HomeComponent,
        WelcomeHeaderComponent,
        RegistrationComponent,
        PageNotFoundComponent,
        LandingPageComponent,
        GettingStartedComponent,
        ResourcesComponent,
        SignupComponent,
        AppManagementComponent,
        EditAppComponent,
        LogoutComponent,
        PoliciesCheckComponent,
        ProfileMgmtComponent,
        HeaderComponent,
        TermsConditionsComponent,
        FooterComponent
    ],
    bootstrap: [AppComponent], imports: [BrowserModule,
        AppRoutingModule,
        FormsModule,
        ConfirmationPopoverModule.forRoot({
            confirmButtonType: 'danger', // set defaults here
        })], providers: [provideHttpClient(withInterceptorsFromDi())] })
export class AppModule { }
